<template>
  <t-base-button>
    <Button v-tooltip.top="tooltip" :label="labelComputed" 
      :class="[
        colorComputed,
        {
          'p-button-text': textualComputed && !texttualActive,
          'p-button-text-back': textualComputed && texttualActive,
          'p-button-rounded': roundedComputed,
          'p-button-nav': navComputed,
          'p-button-textual-active': texttualActive,
          'p-button-nav-active': navActive,
          'centerText': roundedWithTextComputed,
          'p-button-icon': '',
        },
        buttonClass,
        cclass,]" 
      :icon="icon" 
      :iconPos="iconPosition" 
      :disabled="disabled" 
      @click="onClick" 
      :type="type" 
      :style="styleComputed"
      :form="formSubmit"
      @mouseenter="mouseEnter"
      @mouseleave="mouseLeave"
    >
      <img v-if='image' :style="'width:100%;height:100%;margin:0 auto;' + imageStyle" :src="image">
    </Button>
  </t-base-button>
</template>
<script>
import TBaseButton from "./TBaseButton.vue";
import Button from "primevue/button/sfc";

export default {
  components: {
    TBaseButton,
    Button,
  },
  mounted() { },
  computed: {
    roundedComputed() {
      return (
        this.rounded != undefined &&
        (this.rounded === true || this.rounded === "")
      );
    },
    textualComputed() {
      return (
        this.textual != undefined &&
        (this.textual === true || this.textual === "")
      );
    },
    navComputed() {
      return this.nav != undefined && (this.nav === true || this.nav === "");
    },
    labelComputed() {
      if (this.roundedComputed == true && !this.roundedWithText) return "";
      return this.label;
    },
    colorComputed() {
      if (this.navComputed == true) return "";
      return this.color;
    },
    roundedWithTextComputed() {
      return this.roundedWithText;
    },
    computedImage() {
      return this.image
    },
    styleComputed() {
      let newStyle = JSON.parse(JSON.stringify(this.$props.style))
      if (this.computedImage !== "") {
        // newStyle['margin'] = 0
        newStyle['padding'] = '0'
      }
      return newStyle
    }
  },
  props: {
    tooltip: {
      Type: String,
    },
    onClick: {
      Type: Function,
    },
    mouseEnter: {
      Type: Function,
    },
    mouseLeave: {
      Type: Function,
    },
    label: {
      Type: String,
      default: "",
    },
    color: {
      Type: String,
      default: "",
    },
    disabled: {
      Type: Boolean,
      default: false,
    },
    buttonClass: {

    },
    textual: {
      Type: Boolean,
    },
    icon: {
      Type: String,
      default: "",
    },
    type: {
      Type: String,
    },
    iconPosition: {
      Type: String,
      default: "left",
    },
    rounded: {
      Type: Boolean,
    },

    formSubmit: {
      Type: String,
    },
    nav: {
      Type: Boolean,
    },
    style: {
      Type: Object,
      default: {}
    },
    cclass: {
      Type: String
    },
    image: {
      Type: String,
      default: ""
    },
    imageStyle: {
      Type: String,
      default: ''
    },
    roundedWithText: {
      Type: Boolean,
      default: false
    },
    texttualActive: Boolean,
    navActive: Boolean
  },
};
</script>

<style lang='scss'>
.p-tooltip-text	{
    font-size: 10px !important;
}
.centerText {
  padding: 0px !important;

  .p-button-label {
    @include f-button;
    margin: auto;
  }



}
</style>
